module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("form")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("CellFormPreview_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/cell-form-preview/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell-form-preview"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/cell-form-preview",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/CellFormPreview.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { CellFormPreview } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("label and value list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("border-intent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("if set border intent on the left side")])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell-form-preview"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Cell_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/cell/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/cell",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Cell.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Cell } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text on the left")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("right text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the text below title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("redirect link. Can be http(s) protocol; can also be vue-router format")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if this is a link; if true, there will be an arrow on the right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("primary")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("main content area, can be in [‘title’, ‘content’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-loading")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("if show loading icon, good for asynchronous loading")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("left")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("value’s text-align，one of left, right. prop:primary will be set to content if value-align value is right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("border-intent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("if set border intent on the left side")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("arrow-direction")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("arrow direction, one of up, down")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])]), _vm._v(" "), _c('td', [_vm._v("set disabled style for label and arrow (if is-link is true)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("align-items")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("center")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("align-items value")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("right area, you can use default slot instead of prop:value so you can use complicated layout")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_vm._v("[deprecated] the same as default slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_vm._v("icon area before title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("after-title")])]), _vm._v(" "), _c('td', [_vm._v("after title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("child")])]), _vm._v(" "), _c('td', [_vm._v("the child element of the cell, you can add an element with absolute position")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_vm._v("inline-desc slot, the same function as prop:inline-desc but can use html")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.3")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Checker_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/checker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/checker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/checker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Checker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Checker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Checker")]), _vm._v(" is a more flexible component than "), _c('code', [_vm._v("Radio")]), _vm._v(" and "), _c('code', [_vm._v("Checklist")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default-item-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("default checker-item classname")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("selected-item-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("selected check-item classname")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled-item-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("disabled check-item classname")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("radio")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("checker type, should be raido or checkbox")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("selected value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max selected number when type = checkbox")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("radio-required")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])]), _vm._v(" "), _c('td', [_vm._v("whether value is required in radio mode. if true, current selected item will always be selected even after clicking")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("CheckerItem")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("value of current checker-item")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if current item is disabled")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-item-click")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(itemValue, itemDisabled)")])]), _vm._v(" "), _c('td', [_vm._v("emits when current checker-item is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/checker"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Checklist_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/checklist/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/checklist"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/checklist",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Checklist.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Checklist } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("required")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if required")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("options")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("options list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max selected number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min selected number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("random-order")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if place options in a random order")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("check-disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("if disabled item when selectedItems.length === total.length, by using this prop:max no longer works")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("label position, can be set to left or right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('td', [_vm._v("if disable user from selecting")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_vm._v("(value, label)")]), _vm._v(" "), _c('td', [_vm._v("emits when value changes, param:label is supported after v2.5.7")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getFullValue")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get current value with label")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/checklist"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("DatetimeRange_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/datetime-range/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime-range"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/datetime-range",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/DatetimeRange.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { DatetimeRange } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding. For example, [‘2017-01-15’, ‘03’, ‘05’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description of the cell")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder, works when "), _c('code', [_vm._v("value")]), _vm._v(" is empty")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("start date (YYYY-MM-DD)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("end-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("end date (YYYY-MM-DD)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("YYYY-MM-DD")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("display format for date column")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("$emits when value changes, "), _c('code', [_vm._v("(newVal)")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime-range"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Datetime_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/datetime/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/datetime",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Datetime.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Datetime } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("YYYY-MM-DD")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("date format. Special characters are not supported, for example, YYYY-MM-DD HH:mm:ss")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("cell title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description of the cell")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder, works when value is empty")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min-year")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min-year of the form")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max-year")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max-year of the form")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min-hour")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min hour")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max-hour")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("23")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max hour")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("confirm-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ok(确认)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("confirm button’s text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("cancel(取消)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("cancel button’s text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("clear-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom button’s text which shows in the middle of the header")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("year-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the year column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("month-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the month column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("day-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the day column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hour-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the hour column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("minute-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the minute column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("start date, must be YYYY-MM-DD. Please use "), _c('code', [_vm._v("min-hour")]), _vm._v(" and "), _c('code', [_vm._v("max-hour")]), _vm._v(" to limit the range of hours")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("end-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("end date, must be YYYY-MM-DD. Please use "), _c('code', [_vm._v("min-hour")]), _vm._v(" and "), _c('code', [_vm._v("max-hour")]), _vm._v(" to limit the range of hours")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("required")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if required")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("display-format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.11")])]), _vm._v(" "), _c('td', [_vm._v("used to format display value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.6")])]), _vm._v(" "), _c('td', [_vm._v("readonly mode, show like a cell")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])]), _vm._v(" "), _c('td', [_vm._v("control visibility of datetime, require vue^2.3")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("minute-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])]), _vm._v(" "), _c('td', [_vm._v("specify minute list, for instance [‘00’, ‘15’, ‘30’, ‘45’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hour-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])]), _vm._v(" "), _c('td', [_vm._v("specify hour list, for instance [‘09’, ‘10’, ‘11’, ‘12’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default-selected-value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.1")])]), _vm._v(" "), _c('td', [_vm._v("set default selected value, works only when value is empty")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("compute-hours-function")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.5")])]), _vm._v(" "), _c('td', [_vm._v("dynamically set hours list, params "), _c('code', [_vm._v("(value, isToday, generateRange)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("compute-days-function")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('td', [_vm._v("dynamically set days list, params "), _c('code', [_vm._v("({year, month, min, max}, generateRange)")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("trigger element content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.6")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("$emits when value changes, "), _c('code', [_vm._v("(newVal)")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-clear")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("$emits when click the button in the middle of the header")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when datetime shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(type)")]), _vm._v(", type is one of [cancel, confirm]")]), _vm._v(" "), _c('td', [_vm._v("fires when datetime hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.4")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when cancel button is clicked or mask is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.4")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-confirm")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when confirm button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.4")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("FormPreview_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/form-preview/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/form-preview"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/form-preview",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/FormPreview.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { FormPreview } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header-label")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("header label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header-value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("header value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("body-items")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("[]")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("a list of label and value pair")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("footer-buttons")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("[]")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button list. Default is a gray style, and the primary text is highlighted. [{style: ‘primary’, text: ‘text’, onButtonClick: fn(prop:name), link: ‘/path’}]")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/form-preview"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Group_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/group/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/group"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/group",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Group.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Group } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Group")]), _vm._v(" is a special component for wrapping form elements")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("group title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("group title’s color")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("common label width for child components")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("common label text-align for child components")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-margin-right")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("common margin right value for child components")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("gutter")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("set the marginTop value when there is no title")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content body for child components")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.1")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/group"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("InlineCalendar_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/inline-calendar/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/inline-calendar"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/inline-calendar",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/InlineCalendar.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { InlineCalendar } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("calendar value, use "), _c('code', [_vm._v("v-modle")]), _vm._v(" for binding. String (including empty) means single seleciton; array (including empty array) means multiple selection.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("render-month")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("specify which date to render, for example [2018, 8]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("start date with format "), _c('code', [_vm._v("YYYY-MM-dd")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("end-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("end date with format "), _c('code', [_vm._v("YYYY-MM-dd")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-last-month")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show last month’s days")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-next-month")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show next month’s days")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("highlight-weekend")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if highlight weekend days")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("return-six-rows")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if always show six rows")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-header")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if hiding header")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-week-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if hiding week list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("replace-text-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("replace list, for example, {‘TODAY’:‘今’}")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("weeks-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("[‘Su’, ‘Mo’, ‘Tu’, ‘We’, ‘Th’, ‘Fr’, ‘Sa’]")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("week list, starting from "), _c('code', [_vm._v("Sunday")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("render-function")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render function to add extra contents, params "), _c('code', [_vm._v("(line, row, dateData)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("render-on-value-change")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if re-render calendar if value changes, should set to false when showing multi months")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disable-past")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disable the past days, can work with start-date")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disable-future")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disable future days, can work with end-date")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("marks")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.0")])]), _vm._v(" "), _c('td', [_vm._v("(beta) style marks for specified date list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disable-weekend")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('td', [_vm._v("whether disable weekends")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disable-date-function")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('td', [_vm._v("check if a date should be disabled")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("each-day")])]), _vm._v(" "), _c('td', [_vm._v("you can custom how to display each day")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-view-change")])]), _vm._v(" "), _c('td', [_vm._v("(data, index)")]), _vm._v(" "), _c('td', [_vm._v("fires when render month is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.12")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-select-single-date")])]), _vm._v(" "), _c('td', [_vm._v("(currentValue)")]), _vm._v(" "), _c('td', [_vm._v("fires when date is selected in radio mode")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("2.7.6")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getDates")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get current date list")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.11")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("switchViewToToday")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("render current month")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.12")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("switchViewToMonth")])]), _vm._v(" "), _c('td', [_vm._v("(year, month)")]), _vm._v(" "), _c('td', [_vm._v("render specified year and month")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.12")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("switchViewToCurrentValue")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("render with current value’s month")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.12")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/inline-calendar"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Picker_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/picker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/picker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/picker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Picker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Picker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("picker value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("data")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("array list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("columns")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("how many columns in chained-mode")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fixed-columns")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("how many columns will show")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("column-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("custom width for each picker column, for example for a 3-column picker: [1/2, 1/5]")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getNameValues")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get labels of current value")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.1")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/picker"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("PopupPicker_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/popup-picker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-picker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/popup-picker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/PopupPicker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { PopupPicker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n  other props are the same as `Picker`\n")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("picker value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("popup cancel text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("confirm-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("popup confirm text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-name")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show names instead of keys")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description text below label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("popup show (supports the .sync modifier next)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-text-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.0-rc.3")])]), _vm._v(" "), _c('td', [_vm._v("value’s text align")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("display-format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.7")])]), _vm._v(" "), _c('td', [_vm._v("used to format display text on cell, param: (currentValue)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("popup style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('td', [_vm._v("popup title")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot, use scope.labelClass and scope.labelStyle to inherit label styles")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(closeType)")]), _vm._v(" true表示confirm(选择确认), false表示其他情况的关闭")]), _vm._v(" "), _c('td', [_vm._v("emits when popup is closed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-shadow-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(Array ids, Array names)")])]), _vm._v(" "), _c('td', [_vm._v("emits when picker value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.6")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-picker"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("PopupRadio_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/popup-radio/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-radio"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/popup-radio",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/PopupRadio.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { PopupRadio } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("props are the same as cell’s and radio’s. Be aware that it doesnot support fillMode.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.6")])]), _vm._v(" "), _c('td', [_vm._v("readonly, shown like a cell")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-header")])]), _vm._v(" "), _c('td', [_vm._v("popup header slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.3")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("each-item")])]), _vm._v(" "), _c('td', [_vm._v("custom how label displays")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.5")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when popup hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.5")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-radio"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Radio_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/radio/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/radio"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/radio",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Radio.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Radio } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("radio")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":options")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"options\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("radio")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("options")]), _vm._v(" can be plain array, or object list with key=> value:")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" options = [ "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'China'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Japan'")]), _vm._v(" ]\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" options2 = [{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("icon")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://dn-placeholder.qbox.me/110x110/FF2D55/000'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("key")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'001'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("value")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'radio001'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("icon")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://dn-placeholder.qbox.me/110x110/FF2D55/000'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("key")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'002'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("value")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'radio002'")]), _vm._v("\n}]\n")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("`radio` should be used in `Group`.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("radio value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("options")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("option list, can be plain array or array with "), _c('code', [_vm._v("key=>value")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fill-mode")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if add an option user can fill")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fill-placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder for fill input")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fill-label")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label for fill input")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('td', [_vm._v("disable selecting")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("selected-label-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.0")])]), _vm._v(" "), _c('td', [_vm._v("set selected label style")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("each-item")])]), _vm._v(" "), _c('td', [_vm._v("custom how to display each item")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/radio"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Range_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/range/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/range"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/range",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Range.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Range } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("decimal")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show decimals when value is changed")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("100")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("step")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("step value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("minHTML")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom html template for min value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("maxHTML")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom html template for max value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled-opacity")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("opacity value when is disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("rangeBarHeight")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("range bar’s height")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/range"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Rater_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/rater/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/rater"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/rater",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Rater.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Rater } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("total star number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("selected value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("star")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("★")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("start’s symbol text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("active-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type",
    staticStyle: {
      "width": "65px",
      "background-color": "#fc6"
    }
  }, [_vm._v("#fc6")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("symbol color when selected")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("margin")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("margin value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("font-size")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("25")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("font size")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.9")])]), _vm._v(" "), _c('td', [_vm._v("min value")])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/rater"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Search_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/search/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/search"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/search",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Search.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Search } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("搜索(search)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("取消(cancel)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("cancel text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("input value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("results")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("search results, [{title: ‘hello’, otherData: otherValue}], will not show when auto-fixed is false")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("auto-fixed")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if auto fixed on top when input gets focus")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("top")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("0px")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("top value when fixed on top")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("fixed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("position value when pin the component on the top, one of "), _c('code', [_vm._v("fixed")]), _vm._v(", "), _c('code', [_vm._v("absolute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("auto-scroll-to-top")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if auto scroll to top when input gets focus")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("slot above search result")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right")])]), _vm._v(" "), _c('td', [_vm._v("slot on the right of input")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left")])]), _vm._v(" "), _c('td', [_vm._v("slot on the left of input")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-submit")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when form is submitted")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when cancel button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-result-click")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(item)")])]), _vm._v(" "), _c('td', [_vm._v("emits when result item is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-focus")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("when input gets focus")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.10")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-blur")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when input losts focus")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("setFocus")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("set focus on input. you should call this method in a click event’s callback function on Safari")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("setBlur")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("make input lost focus")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.6")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/search"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Selector_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/selector/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/selector"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/selector",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Selector.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Selector } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("direction")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("align value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("options")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("option list, "), _c('code', [_vm._v("['one', 'two']")]), _vm._v(" or "), _c('code', [_vm._v("[{ key: KEY, value: VALUE }]")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("name")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form name")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if the select is readonly")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-map")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.2")])]), _vm._v(" "), _c('td', [_vm._v("set a [value, label] pair for automatically transforming API data")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getFullValue")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get full value including all the props(if option items are object)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.2")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/selector"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XAddress_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-address/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-address"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-address",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XAddress.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-address")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-address")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XAddress } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// you can import built-in data")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XAddress, ChinaAddressV3Data } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// if you need older data")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XAddress, ChinaAddressV1Data } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\nyou can view source data at [src/datas](https://github.com/airyland/vux/tree/v2/src/datas).\n")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("`x-address` should be used in `Group`")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("raw-value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if the initial value is "), _c('code', [_vm._v("string value")]), _vm._v(" instead of "), _c('code', [_vm._v("id value")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("address data")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description text below label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-district")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if hide district column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-text-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("align setting of "), _c('code', [_vm._v("value")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("popup style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.8")])]), _vm._v(" "), _c('td', [_vm._v("popup show (supports the .sync modifier next)")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when being closed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when being open")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-shadow-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(Array ids, Array names)")])]), _vm._v(" "), _c('td', [_vm._v("emits when picker value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.6")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-address"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XButton_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-button/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-button"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-button",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XButton.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XButton } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("default")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button style type, one of default, primary, warn")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disable the button")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button text, has the same function as default slot")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mini")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use smaller style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("plain")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use plain styles which has no backgroundColor")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("action-type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button’s type value, one of "), _c('code', [_vm._v("submit")]), _vm._v(", "), _c('code', [_vm._v("button")]), _vm._v(", "), _c('code', [_vm._v("reset")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])]), _vm._v(" "), _c('td', [_vm._v("vue-router path, "), _c('code', [_vm._v("BACK")]), _vm._v(" is alias to "), _c('code', [_vm._v("go(-1)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-loading")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("show loading icon")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("gradients")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.4")])]), _vm._v(" "), _c('td', [_vm._v("iOS design gradients, Array length should be 2")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("button text")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-button"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XInput_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-input/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-input"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-input",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XInput.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XInput } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("input value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("text")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("input type, one of "), _c('code', [_vm._v("text")]), _vm._v(","), _c('code', [_vm._v("number")]), _vm._v(","), _c('code', [_vm._v("email")]), _vm._v(","), _c('code', [_vm._v("password")]), _vm._v(","), _c('code', [_vm._v("tel")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom validating function, should return "), _c('code', [_vm._v("{valid:true}")]), _vm._v(" or "), _c('code', [_vm._v("{valid:false, msg: error msg}")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("required")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if is required")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-clear")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show clear icon")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("minlength for input")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("maxlength for input")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if input is disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if input is readonly")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("debounce")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("debounce time")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("left")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])]), _vm._v(" "), _c('td', [_vm._v("placeholder align value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("left")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text-align setting for value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("set label width which will not be overwritten by $parent.labelWidth")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('td', [_vm._v("(beta) value mask, 9 for DIGIT, A for ALPHA, S for ALPHA AND DIGIT")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("should-toast-error")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])]), _vm._v(" "), _c('td', [_vm._v("whether toast error when clicking on error icon")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("restricted-label")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right-full-height")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-blur")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value, $event)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-focus")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value, $event)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-enter")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value, $event)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-error-icon")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(error)")])]), _vm._v(" "), _c('td', [_vm._v("fires when clicking error icon")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("focus")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get input focus")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("blur")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("remove focus from input")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("reset")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value = '')")])]), _vm._v(" "), _c('td', [_vm._v("reset input value and clear errors")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.10")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-input"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XNumber_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-number/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-number"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-number",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XNumber.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XNumber } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-number")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-number")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("`x-number` shoule be used in `Group`")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("minimum number of value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("maximum number of value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("step")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("step value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fillable")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use can fill the number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("50px")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("width of the input element")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("button-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("square")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button styles, [‘square’, ‘round’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("align setting of the selecting area")])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-number"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XSwitch_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-switch/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-switch"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-switch",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XSwitch.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XSwitch } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-switch")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-switch")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("`x-switch` should be used in `Group`.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("component’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("desctiption text below the label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("prevent-default")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('td', [_vm._v("prevent from setting value on being clicked")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-map")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("[false, true]")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('td', [_vm._v("customize not-boolean values")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("triggers when value change, params is (currentValue)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(newVal, oldVal)")])]), _vm._v(" "), _c('td', [_vm._v("triggers when being clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-switch"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XTextarea_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-textarea/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-textarea"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-textarea",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XTextarea.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XTextarea } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])]), _vm._v(" "), _c('td', [_vm._v("description text below title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-counter")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show the text length counter")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("maxlength limit")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("name")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s name")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("rows")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s rows attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cols")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("30")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s cols attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("height")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s readonly attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s disabled attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("autosize")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("whether set auto height for textarea")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("restricted-label")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("triggers when value changes")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-focus")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("focus event")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.11")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-blur")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("blur event")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.11")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("updateAutosize")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("reset autosize, if value is not empty initially, you should call this function to update size")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.1")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-textarea"
    }
  }, [_vm._v("Demo page")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d835f29", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-3d835f29"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/components_form-12.vue
// module id = 2651
// module chunks = 583